export default __webpack_public_path__ + "static/media/icon-hurricane.1e259ad7.svg";